import { type FactGroup } from '@/karehero-app/tell-us-once/intake/FactList';
import { RECIPIENT } from '@/karehero-app/tell-us-once/intake/content';

// CONCEPT. Coming back to the benefits check from Money: what they told it, as
// answers they can change, then Check again. Margaret's answers as calculator
// 1.0 has them, except the carer's hours, which start under 35 so changing
// them has something to show.

const R = RECIPIENT;

export const RECHECK = {
  check: 'Check again',
  /** The chip on a result the second check found and the first didn't. */
  fresh: 'New',
};

/** The result the changed hours bring in, by name, from OTHER_BENEFITS. */
export const RECHECK_FOUND = "Carer's Allowance";

export const RECHECK_ANSWERS: FactGroup[] = [
  {
    label: `About ${R}`,
    rows: [
      { id: 'lives', label: `Where ${R} lives`, value: 'England' },
      { id: 'age', label: `${R}'s age`, value: '66 or older' },
      { id: 'when', label: 'When help is needed', value: 'Day and night' },
      { id: 'home', label: 'In a care or nursing home', value: 'No' },
    ],
  },
  {
    label: 'Health',
    rows: [
      {
        id: 'condition',
        label: 'Disability or long-term condition',
        value: 'Yes, dementia',
      },
      {
        id: 'six-months',
        label: 'Had it for six months or more',
        value: 'Yes',
      },
      { id: 'terminal', label: 'Terminal illness', value: 'No' },
      { id: 'adapting', label: 'Home needs adapting', value: 'No' },
    ],
  },
  {
    label: 'Care',
    rows: [
      { id: 'carer', label: `Caring for ${R} unpaid`, value: 'Yes, you' },
      {
        id: 'hours',
        label: 'Hours a week',
        value: 'Under 35',
        control: 'choice',
        choices: ['Under 35', '35 or more'],
      },
    ],
  },
  {
    label: 'Money',
    rows: [
      {
        id: 'benefits',
        label: `Benefits ${R} already gets`,
        value: 'None of these',
      },
      { id: 'partner', label: 'Partner or spouse', value: 'Yes, 66 or older' },
      {
        id: 'savings',
        label: 'Savings',
        value: 'Under £16,000',
        control: 'choice',
        choices: ['Under £16,000', '£16,000 to £23,250', 'Over £23,250'],
      },
      {
        id: 'income',
        label: 'Combined weekly income',
        value: 'Under £364',
        control: 'choice',
        choices: ['Under £364', '£364 to £450', 'Over £450'],
      },
    ],
  },
];
